<template>
  <div class="Landing">
    <b-navbar
      toggleable="md"
      type="dark"
      variant="dark"
      fixed="top"
      style="background: rgba(46, 52, 60, 1) !important;"
    >
      <b-navbar-brand href="#" class="text-lg font-weight-bold">
        <span class="text-info">SOON</span>
        <span class="text-gray-200">FORWARD</span>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" class="border-0"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav></b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav
          class="ml-auto d-flex align-items-center text-gray-300 text-sm font-weight-bold"
        >
          <b-nav-item href="#home">Home</b-nav-item>
          <b-nav-item href="#approach">Approach</b-nav-item>
          <b-nav-item href="#footer">Connect</b-nav-item>
          <!-- <b-nav-item to="/login">Login</b-nav-item> -->
          <a href="#demo">
            <b-button
              variant="outline-light"
              class="text-xs py-1 px-2 ml-3"
              style="height: fit-content"
            >
              Book Demo
            </b-button>
          </a>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div
      id="home"
      class="d-flex justify-content-left align-items-center"
      style="height: 100vh; overflow: hidden;"
    >
      <!-- <img
        class="hero"
        src="../assets/ship.png"
        style="flex: none;
          filter: contrast(90%);"
      /> -->

      <video autoplay muted loop playsInline poster style="object-fit: cover;
        width: 100%; height: 100%;
        position: absolute; top: 0; left: 0;
        filter: brightness(0.7);">
        <source src="../assets/Landing_Video.mp4" type="video/mp4">
      </video>
      
      <div class="d-flex justify-content-left" style="position: absolute; bottom: 100px;">
        <div
          class="text-light title font-weight-bold mx-3"
        >
        <div>
          Your Package, in Motion,
        </div>
        <div>
          SoonForward
          </div>
         <div>
            <a href="#demo">
              <b-button
                class="text-6xl"
                type="demo"
                variant="primary"
              >Book Demo</b-button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      id="approach"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 80vh; overflow-x: hidden; background: white;"
    >
      <div class="justify-content-center align-items-center my-5" style="max-width: 1000px;">
        <div>
          <h3
            class="font-weight-bold text-5xl text-info"
          >
            Our Approach
          </h3>
          <div class="justify-content-center" style="font-style: italic; width: 100%; box-sizing: border-box;  padding: 0 50px;">
            <h4 class="text-3xl mb-5 text-info" style="font-style: italic;">
              Introducing the online marketplace that connects shipping companies and their customers
            </h4>
          </div>
        </div>

        <div class="d-flex justify-content-center align-items-center">
          <div
            class="px-1 pt-1 pb-1 mx-1 mb-1"
            style="width: 500px;"
          >
            <div class="text-xl mb-3">
              <img
                class="crisp hero"
                src="../assets/Owner_Warehouse.jpg"
                style="flex: none; height: 500px; width: 500px; border-radius: 10%; object-fit: cover;"
              />
            </div>
          </div>
          <div class="mx-1">
            <h4 class="text-3xl text-info">
              For Shipping Companies
            </h4>
            <h4 class="text-xl" style="width: 100%; box-sizing: border-box;  padding: 0 50px;">
              Streamline your operations and boost your bottom line
            </h4>

            <div class="d-flex" style="width: 100%; box-sizing: border-box;  padding: 0 44px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" class="bi bi-coin" viewBox="0 0 16 16">
                <path d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518z"/>
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                <path d="M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11m0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/>
              </svg>
              <div>
              <h4 class="text-xl font-weight-bold">Get Paid Faster</h4>
              <p class="text-xl">
              Expand your abilities to accept cashless payments from your customers
              </p>
              </div>
            </div>
            <div class="d-flex" style="width: 100%; box-sizing: border-box;  padding: 0 44px;">
              <b-icon-people-fill scale="1.00" class="text-6xl my-3" />
              <div>
              <h4 class="text-xl font-weight-bold">Attract More Customers</h4>
              <p class="text-xl text-gray-600">
                Make it easy for customers to find and book your services online
              </p>
              </div>
            </div>
             <div class="d-flex" style="width: 100%; box-sizing: border-box;  padding: 0 44px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" fill="currentColor" class="bi bi-graph-up-arrow" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M0 0h1v15h15v1H0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5"/>
              </svg>
              <div>
                <h4 class="text-xl font-weight-bold">Operate Efficiently</h4>
                <p class="text-xl text-gray-600">
                Improve inventory management and reduce costly mistakes
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center align-items-center" >
          <div class="mx-1">
            <h4 class="text-3xl text-info">
              For Customers
            </h4>
            <h4 class="text-xl" style="width: 100%; box-sizing: border-box;  padding: 0 50px;">
              Skip the hassle and book shipping services online
            </h4>
             <div class="d-flex" style="width: 100%; box-sizing: border-box;  padding: 0 44px;">
              <b-icon-phone scale="1.00" class="text-6xl my-4" />
              <div>
                <h4 class="text-xl font-weight-bold">24/7 Online Booking</h4>
                <p class="text-xl text-gray-600">
                  Conveniently book from anywhere with your device
                </p>
              </div>
            </div>
             <div class="d-flex" style="width: 100%; box-sizing: border-box;  padding: 0 44px;">
              <b-icon-search scale="0.95" class="text-6xl my-4" />
              <div>
                <h4 class="text-xl font-weight-bold">Discover Your Options</h4>
                <p class="text-xl text-gray-600">
                  Easily browse for shipping services and compare the best solutions in one view
                </p>
              </div>
            </div>
             <div class="d-flex" style="width: 100%; box-sizing: border-box;  padding: 0 44px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" fill="currentColor" class="bi bi-qr-code" viewBox="0 0 16 16">
                <path d="M2 2h2v2H2z"/>
                <path d="M6 0v6H0V0zM5 1H1v4h4zM4 12H2v2h2z"/>
                <path d="M6 10v6H0v-6zm-5 1v4h4v-4zm11-9h2v2h-2z"/>
                <path d="M10 0v6h6V0zm5 1v4h-4V1zM8 1V0h1v2H8v2H7V1zm0 5V4h1v2zM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8zm0 0v1H2V8H1v1H0V7h3v1zm10 1h-1V7h1zm-1 0h-1v2h2v-1h-1zm-4 0h2v1h-1v1h-1zm2 3v-1h-1v1h-1v1H9v1h3v-2zm0 0h3v1h-2v1h-1zm-4-1v1h1v-2H7v1z"/>
                <path d="M7 12h1v3h4v1H7zm9 2v2h-3v-1h2v-1z"/>
              </svg>
              <div>
                <h4 class="text-xl font-weight-bold">Shipment Tracking</h4>
                <p class="text-xl text-gray-600">
                  Get real-time status updates for your bookings
                </p>
              </div>
            </div>
          </div>
          <div
            class="px-1 pt-1 pb-1 mx-1 mb-1"
            style="width: 500px;"
          >
            <div class="text-xl mb-3">
              <img
                class="crisp hero"
                src="../assets/Family_Packing.jpg"
                style="flex: none; height: 500px; width: 500px; border-radius: 10%; object-fit: cover;"
              />
            </div>
          </div>
        </div>
        
      
        <!-- <div class="d-flex justify-content-center" style="max-width: 800px;">
          <div
            class="bg-light text-dark rounded-lg shadow px-5 pt-4 pb-5 mx-3 mb-3"
            style="width: 300px;"
          >
            <b-icon-diagram3-fill scale="1.25" class="text-6xl text-gray-600 my-4" />
            <h4 class="text-3xl font-weight-bold text-info mb-4">Improve Visibility</h4>
            <p class="text-xl text-gray-600">
              Ensure accountability by offering relevant details and updates to your workers and
              customers.
            </p>
          </div>
          <div
            class="bg-light text-dark rounded-lg shadow px-5 pt-4 pb-5 mx-3 mb-3"
            style="width: 300px;"
          >
            <b-icon-cash scale="1.25" class="text-6xl text-gray-600 my-4" />
            <h4 class="text-3xl font-weight-bold text-info mb-4">Minimize Costs</h4>
            <p class="text-xl text-gray-600">
              Reduce mistakes and risks with an intuitive, integrated system with built-in
              safeguards.
            </p>
          </div>
          <div
            class="bg-light text-dark rounded-lg shadow px-5 pt-4 pb-5 mx-3 mb-3"
            style="width: 300px;"
          >
            <b-icon-graph-up scale="1.25" class="text-6xl text-gray-600 my-4" />
            <h4 class="text-3xl font-weight-bold text-info mb-4">Increase Productivity</h4>
            <p class="text-xl text-gray-600">
              Leverage superior analytics to boost performance and grow your business.
            </p>
          </div>
        </div> -->
        
      </div>
    </div>
    <!-- <div
      id="subscribe"
      style="height: 100vh; overflow: hidden; display: flex; justify-content: center;
        align-items: center; position: relative;"
    >
      <img
        class="hero"
        src="../assets/shelves.png"
        style="flex: none;
          filter: blur(1px) contrast(70%) brightness(0.9) grayscale(0.1);"
      />
      <div style="position: absolute;">
        <div
          class="text-light px-5 py-3 mx-3 rounded shadow"
          style="background: rgba(46, 52, 60, 0.9); max-width: 600px;"
        >
          <h3 class="font-weight-bold" style="color: rgb(243 156 49);">Stay Informed</h3>
          <p class="text-lg">
            Subscribe to our newsletter to receive our updates and news.
          </p>
          <form @submit.prevent="subscribe">
            <b-input-group class="mt-3 mb-4">
              <b-form-input
               name="email"
               type="email"
               placeholder="Email..."
               v-model="update"
               required
              class="border-0 text-lg"
              />
              <b-input-group-append>
                <b-button
                  type="subscribe"
                  class="text-lg border-0"
                  variant="primary"
                  style="background: rgb(245 147 26);"
                >Subscribe</b-button>
              </b-input-group-append>
            </b-input-group>
          </form>
        </div>
      </div>
    </div> -->
    <div
      id="testimony"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 30vh; overflow-x: hidden; background: white"
    >
      <div>
        <h3
          class="font-weight-bold text-5xl my-5 text-info"
        >Trusted By</h3>
        <!-- <div class="d-flex justify-content-center text-light" style="margin-bottom: 100px; max-width: 1000px;">
          <div
              class="text-light px-1 pt-1 pb-1 mx-1 mb-1"
              style="width: 300px;"
            >
            <div class="text-xl mb-3">
              <div class="text-2xl font-weight-bold">Michelle</div>
              <div class="text-lg">Mobile App</div>
            </div>
            <p class="text-base font-italic">
              This app will be a game changer!!! I will definitely be using
              this to book and track my shipments to St. Lucia.
            </p>
            <span class="text-5xl">❞</span>
          </div>

          <div
            class="text-light px-1 pt-1 pb-1 mx-1 mb-1"
            style="width: 300px;"
          >
            <div class="text-xl mb-3">
              <div class="text-2xl font-weight-bold">Handel</div>
              <div class="text-lg">Web App</div>
            </div>
            <p class="text-base font-italic">
            With 20+ years of experience as an importer, I recommend SoonForward
            because it is an innovative, user-friendly application.
            </p>
            <span class="text-5xl">❞</span>
          </div>

          <div
               class="text-light px-1 pt-1 pb-1 mx-1 mb-1"
              style="width: 300px;"
            >
            <div class="text-xl mb-3">
              <div class="text-2xl font-weight-bold">Kijah</div>
              <div class="text-lg">Mobile App</div>
            </div>
            <p class="text-base font-italic">
              This app eliminates my anxiety when using a new app because
              its design well and easy to navigate. It has all you could ask for when managing
              your shipments
            </p>
            <span class="text-5xl">❞</span>
          </div>
        </div> -->
        <!-- <h3
          class="font-weight-bold text-light mt-4 text-5xl"
          style="margin-bottom: 60px;"
        >Thanks to Our Supporters</h3> -->
        <div class="d-flex justify-content-center" style=" color: rgb(42 47 66);">
           <div
              class="px-1 pt-1 pb-1 mx-1 my-5 mb-1"
              style="width: 350px;"
          >
            <div class="mb-3">
              <img
                class="hero"
                src="../assets/VSLogo.png"
                style="flex: none; max-width:350px;"
              />
            </div>
          </div>

          <div
              class="px-1 pt-1 pb-1 mx-1 mb-1"
              style="width: 300px;"
          >
            <div class="mb-3">
              <img
                class="hero"
                src="../assets/Intuit.jpg"
                style="flex: none; max-width: 300px;"
              />
            </div>
          </div>

          <div
              class="px-1 pt-1 pb-1 mx-1 my-4 mb-1"
              style="width: 300px;"
          >
            <div class="mb-3">
              <img
                class="hero"
                src="../assets/msoftstartups.jpg"
                style="flex: none; max-width: 300px;"
              />
            </div>
          </div>

           <div
              class="px-1 pt-1 pb-1 py-4 mb-1"
              style="width: 300px;"
          >
            <div class="mb-3">
              <img
                class="hero"
                src="../assets/communitasAmerica.png"
                style="flex: none; max-width: 300px;"
              />
            </div>
          </div>

            <div
              class="px-1 pt-1 pb-1 py-4 mb-1"
              style="width: 300px;"
          >
            <div class="mb-3">
              <img
                class="hero"
                src="../assets/NYCEDC.png"
                style="flex: none; max-width: 300px;"
              />
            </div>
          </div>
<!-- 
          <div
              class="px-1 pt-1 pb-1 mb-1"
              style="width: 300px;"
          >
            <div class="mb-3">
              <img
                class="hero"
                src="../assets/lucianshippinglogo.png"
                style="flex: none; max-width: 300px; "
              />
            </div>
          </div> -->
<!-- 
          <div
              class="px-1 pt-1 pb-1 py-3 mb-1"
              style="width: 150px;"
          >
            <div class="mb-3">
              <img
                class="hero"
                src="../assets/BBF.png"
                style="flex: none; max-width: 150px;"
              />
            </div>
          </div> -->

        </div>

        <!-- <div class="d-flex justify-content-center" style=" color: rgb(42 47 66);">

          <div
              class="px-1 pt-1 pb-1 py-5 mb-1"
              style="width: 300px;"
          >
            <div class="mb-3">
              <img
                class="hero"
                src="../assets/NYCEDC.png"
                style="flex: none; max-width: 300px;"
              />
            </div>
          </div>

          <div
              class="px-1 pt-1 pb-1 mx-1 mb-1"
              style="width: 300px;"
          >
            <div class="mb-3">
              <img
                class="hero"
                src="../assets/lucianshippinglogo.png"
                style="flex: none; max-width: 300px; "
              />
            </div>
          </div>

          <div
              class="px-1 pt-1 pb-1 py-3 mb-1"
              style="width: 180px;"
          >
            <div class="mb-3">
              <img
                class="hero"
                src="../assets/BBF.png"
                style="flex: none; max-width: 180px;"
              />
            </div>
          </div>
        </div> -->
      </div>
      <div>
    </div>
    
    </div>
    <div
      id="demo"
      class="d-flex justify-content-center align-items-center"
      style="height: 60vh; overflow: hidden; position: relative;"
    >
      <img
        class="hero"
        src="../assets/shelves.png"
        style="object-fit: cover;
        width: 100%; height: 100%;"
      />


      <div class="d-flex justify-content-center" style="position: absolute;">
        <div
          class="px-4 py-3 mx-3 rounded"
          style="background: rgba(46, 52, 60, 0.8); width: 400px"
        >
          <h3 class="font-weight-bold text-gray-200 mb-4">Request a Demo</h3>
          <b-form @submit.prevent="demo">
            <b-form-input
              id="input-1"
              class="border-0 mb-4"
              type="text"
              v-model="name"
              placeholder="Name"
              required
            ></b-form-input>
            <b-form-input
              id="input-1"
              class="border-0 mb-4"
              type="email"
              v-model="email"
              placeholder="Email"
              required
            ></b-form-input>
            <b-form-textarea
              id="textarea"
              class="border-0 mb-4"
              v-model="text"
              placeholder="Add a message..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
             <vue-recaptcha
              :loadRecaptchaScript="true"
              ref="recaptcha"
              size="invisible"
              @verify="onVerify"
              @expired="onExpired"
              sitekey="6Lc2z68cAAAAADdbLV1V1Bbh1IbfeEsHkDKmiSWx">
              </vue-recaptcha>
              <b-button type="demo" class="text-sm" variant="primary">Submit</b-button>
          </b-form>
        </div>
      </div>
    </div>
    
    <div
      id="footer"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 20vh; overflow-x: hidden; background: rgba(46, 52, 60, .8);"
    >
     <div>
      <div class="d-flex justify-content-center text-light"
      >
          <div
            class="px-1 pt-1 pb-1 mx-1 mb-1"
            style="max-width: 250px"
          >
            <div class="text-2xl mb-3">
              <span class="text-info">SOON</span>
              <span class="text-gray-200">FORWARD</span>
            </div>
             <div class="text-lg mb-3">
                <span>Move Forward With SoonForward</span>
              </div>
          </div>
          <div
            class="px-1 pt-1 pb-1 mx-1 mb-1"
            style="max-width: 250px"
          >
            <div class="text-2xl mb-3" >
              <span>Connect With Us</span>
            </div>
             <div class="mb-3" style="width: 100%; box-sizing: border-box;  padding: 0 10px;">
              <a href="https://wa.me/13474601773" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-whatsapp " viewBox="0 0 16 16">
                  <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                </svg>
              </a>
              <a href="https://instagram.com/officialsoonforward" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-instagram mx-3" viewBox="0 0 16 16">
                  <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
                </svg>
              </a>
              <a href="https://www.facebook.com/people/SoonForward/100085242398681" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
                  <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
                </svg>
              </a>
              </div>
          </div>
          <div
              class="px-1 pt-1 pb-1 mx-1 mb-1"
            style="max-width: 250px"
          >
            <div class="text-2xl mb-3" >
              <span>Company</span>
            </div>
            <div class="text-lg mb-3">
              Privacy Policy
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="d-flex justify-content-center align-items-center text-gray-300 text-sm"
      style="height: 5vh; overflow-x: hidden; background: rgba(46, 52, 60, 1);"
    >
      Copyright © {{CurrentYear}} SoonForward. All Rights Reserved
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import postEmail from '../api/email';

export default {
  name: 'Landing',
  components: { 'vue-recaptcha': VueRecaptcha },
  data() {
    return {
      flag: '',
      name: '',
      email: '',
      text: '',
      update: '',
    };
  },
  computed:{
    CurrentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    onVerify(token) {
      let data = {};
      this.$refs.recaptcha.reset();
      if (this.flag === 'demo') {
        data = {
          data: {
            name: this.name,
            email: this.email,
            message: this.text,
            flag: this.flag,
            captchaToken: token,
          },
        };
      } else {
        data = {
          data: {
            email: this.update, flag: this.flag, captchaToken: token,
          },
        };
      }
      postEmail(data)
        .then((resp) => {
          console.log('Successfully POSTed');
          console.log(resp);
          if (this.flag === 'demo') {
            this.name = '';
            this.email = '';
            this.text = '';
          } else {
            this.update = '';
          }
        }).catch((err) => {
          console.log(err);
        });
    },
    onExpired() {
      this.$refs.recaptcha.reset();
    },
    demo() {
      this.flag = 'demo';
      this.$refs.recaptcha.execute();
    },
    subscribe() {
      this.flag = 'subscribe';
      this.$refs.recaptcha.execute();
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');

* {
  font-family: 'Roboto', sans-serif;
}

@media screen and (max-width: 1000px) {
  div#approach > div > div {
    flex-direction: column !important;
  }

  div#approach > div > div > div {
    width: 95% !important;
  }

  div#testimony > div > div {
    flex-direction: column !important;
  }

  div#testimony > div > div > div {
    width: 100% !important;
  }
}

@media screen and (max-width: 768px) {
  nav {
    flex-direction: row-reverse;
  }
}

@media screen and (min-width: 1287.27px) {
  img.hero {
    width: 100%;
    height: auto;
  }
}

.text-info {
  color: #258ebe !important;
}
.crisp {
  image-rendering:-webkit-optimize-contrast;
}

.title {
  font-size: 7vh;
}
</style>
